import React from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

/**
 * Minimal i18n configuration for standalone widgets
 * Provides basic translations for federated components
 */

// Initialize i18n if not already initialized
if (!i18n.isInitialized) {
  i18n
    .use(initReactI18next)
    .init({
      resources: {
        en: {
          translation: {
            // SectionGrid translations
            "sectionGridCTA": "Load More",
            
            // SectionItemVideo translations
            "today": "Today",
            "tomorrow": "Tomorrow",
            "itemVideoAltText": "{{name}}"
          }
        }
      },
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false
      }
    });
}

/**
 * Provides i18n context for federated components in standalone widgets
 */
const WidgetI18nProvider = ({ children }) => {
  return (
    <I18nextProvider i18n={i18n}>
      {children}
    </I18nextProvider>
  );
};

export default WidgetI18nProvider;

